<template>
  <div>
    <div>
      <div style="margin: 10px 20px">申请服务类型</div>
      <van-radio-group v-model="selectedItemType" style="margin-top: 10px">
        <van-cell-group inset>
          <van-cell v-for="(item,index) in $store.state.ClerkItemTypeEnum.list()"
                    v-if="item.value != 'emotion'"
                    :title="item.label"  clickable @click="selectedItemType = item.value">
            <template #right-icon>
              <van-radio :name="item.value" />
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>

      <div v-if="selectedItemType === 'gaming'" style="padding: 15px">
        <div style="margin: 10px">选择游戏技能</div>
        <van-field
            :value="categoryNames"
            center
            is-link
            label="游戏技能"
            placeholder="请选择游戏技能"
            readonly
            @click="categoryPickerShow = true"/>
      </div>

      <!-- 选择游戏技能 -->
      <van-popup v-model="categoryPickerShow"  :lazy-render="false" position="bottom">
        <div style="text-align: right; margin: 10px 20px;background: #fff" @click="categoryPickerShow = false">确定</div>
        <van-checkbox-group v-model="categoryIds" :max="clerkCategoryCount" @change="categoryChange">
          <van-checkbox v-for="(item,index) in categoryList" :name="item.id" class="category">
            {{item.name}}
          </van-checkbox>
        </van-checkbox-group>
      </van-popup>

      <div class="text-center" style="position: fixed;bottom: 10px;left: 50%;transform: translateX(-50%)">
        <van-button type="primary" size="large" @click="submit" style="padding: 0 20px">提交申请</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import {
  Cell,
  CellGroup,
  Button,
  Toast,
  Dialog,
  Field,
  Icon,
  Radio,
  RadioGroup,
  Popup,
  CheckboxGroup,
  Checkbox
} from 'vant';
import {getClerk, updateItemType} from '@/api/clerk/clerk'
import { getCategoryList } from '@/api/category'

Vue.use(Cell)
    .use(CellGroup)
    .use(Radio)
    .use(RadioGroup)
    .use(CheckboxGroup)
    .use(Checkbox)
    .use(Button)
    .use(Toast)
    .use(Dialog)
    .use(Field)
    .use(Icon)
    .use(Popup)

export default {
  name: 'updateItemType',
  data() {
    return {
      selectedItemType: null,
      clerkCategoryIds: [],
      categoryIds: [],
      currentItemType: [],
      categoryList: [],
      categoryNames: [],
      categoryPickerShow: false,
    }
  },
  mounted() {
    this.loadData()
    this.loadCategoryList()
  },
  methods: {
    categoryChange(selected){
      this.categoryIds = selected
      let categoryNames= []
      for (const item of this.categoryList){
        if(selected.includes(item.id)){
          categoryNames.push(item.name)
        }
      }
      this.categoryNames = categoryNames.toString()
    },
    loadData() {
      Toast.loading({
        mask: true,
        message: '加载中...'
      })
      // 获取店员
      getClerk().then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          this.currentItemType = data.clerk.itemType ? data.clerk.itemType : ['treeHole'];
          this.clerkCategoryIds = data.clerk.clerkCategoryIds;
        } else {
          Dialog.alert({
            title: '加载服务类型失败',
            message: data.msg
          })
        }
      })
    },
    loadCategoryList(){
      // 获取分类列表
      getCategoryList(JSON.stringify('gaming')).then(res => {
        const data = res.data
        if (data.code == 0) {
          this.categoryList = data.list
        } else {
          Dialog.alert({
            title: '加载分类失败',
            message: data.msg
          })
        }
        })
    },
    submit() {
      if(this.selectedItemType == 'gaming' && this.categoryIds.length === 0){
        return Toast('请选择游戏技能')
      }
      Toast.loading({
        mask: true,
        message: '请稍候...'
      })
      updateItemType(this.selectedItemType,JSON.stringify(this.categoryIds)).then(res => {
        Toast.clear()
        const data = res.data;
        if (data.code == 0) {
          Dialog.alert({
            title: '提交申请成功'
          }).then(() => {
            this.$router.back(-1)
          })
        } else {
          this.loadData()
          Dialog.alert({
            title: '提交申请失败',
            message: data.msg
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.category{
  padding: 10px;
}
</style>
